
import { LogHelper } from "@/common/LogHelper";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ElectronicScreenState } from "@/common/glboalconstant";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";

// import el from "element-ui/src/locale/lang/el";

@Component({
  name: "RankingList2",
  components: {},
  props: [
    "wholeTopEfficiency",
    "avgEfficiency",
    "avgEfficiencyRank",
    "lastHourAvgEfficiency",
  ],
  watch: {
    wholeTopEfficiency: {
      handler(newone, oldone) {
        this.showData.wholeTopEfficiency = newone;
      },
    },
    avgEfficiency: {
      handler(newone, oldone) {
        this.showData.avgEfficiency = newone;
      },
    },
    avgEfficiencyRank: {
      handler(newone, oldone) {
        this.showData.avgEfficiencyRank = newone;
      },
    },
    lastHourAvgEfficiency: {
      handler(newone, oldone) {
        this.showData.lastHourAvgEfficiency = newone;
      },
    },
  },
})
export default class extends Vue {
  public fieldValue = 1500;
  public showData = {
    avgEfficiency: "0",
    lastHourAvgEfficiency: "0",
    avgEfficiencyRank: "0",
    frequencyRank: "0",
    wholeTopEfficiency: "0",
  };

  public electronicScreenStateMessage = "未配置";
  public electronicScreenState_style = {
    color: "gray",
  };
  public electronicScreenShow = false;

  mounted() {
    // try {
    //   obj_Common.register_getfieldvalue(this.updatefieldValue);
    // } catch (error) {
    //   LogHelper.Error(
    //     "[错误]:注册个人操作排行榜数据的回调函数执行失败(旧):" + error
    //   );
    // }
    try {
      if (typeof obj_RankingList_Core !== "undefined") {
        obj_RankingList_Core.registerJavaScriptCallback(
          "RankingListRefreshState",
          (value) => {
            this.showData.avgEfficiency = value.avgEfficiency;
            this.showData.lastHourAvgEfficiency = value.lastHourAvgEfficiency;
            this.showData.avgEfficiencyRank = value.avgEfficiencyRank;
            this.showData.frequencyRank = value.frequencyRank;
            this.showData.wholeTopEfficiency = value.wholeTopEfficiency;
          }
        );
        obj_RankingList_Core.registerJavaScriptCallback(
          "RankingListRefreshFieldValue",
          (value) => {
            this.fieldValue = value;
          }
        );
      }
    } catch (error) {
      LogHelper.Error(
        "[错误]:注册个人操作排行榜数据的回调函数执行失败(新):" + error
      );
    }
    try {
      if (typeof obj_ElectronicScreen_Core !== "undefined") {
        obj_ElectronicScreen_Core.registerJavaScriptCallback(
          "ElectronicScreenRefreshState",
          (value) => {
            if (Number.isNaN(value)) {
              return;
            }
            console.log("收到电子屏链接状态更新:" + value.toString());
            this.ShowElectronicScreen(value);
          }
        );
        let _value = obj_ElectronicScreen_Core.findElectronicScreenState();
        this.ShowElectronicScreen(_value);
      } else {
        LogHelper.Error("obj_ElectronicScreen_Core未注册");
      }
    } catch (error) {
      LogHelper.Error("电子屏状态显示失败" + error.toString());
    }
    try {
      if (
        SystemConfigModule.globalData.CurrentDeviceType == 2 ||
        SystemConfigModule.globalData.CurrentDeviceType == 7 ||
        SystemConfigModule.globalData.CurrentDeviceType == 8
      ) {
        this.electronicScreenShow = true;
      }

    } catch (error) {
      LogHelper.Error("电子屏状态异常:" + error.toString());
    }
  }

  public updatefieldValue(value) {
    this.fieldValue = value;
  }
  public ShowElectronicScreen(value) {
    switch (value) {
      case ElectronicScreenState.notConfigured:
        this.electronicScreenStateMessage = "未配置";
        this.electronicScreenState_style.color = "gray";
        break;
      case ElectronicScreenState.connectSucceeded:
        this.electronicScreenStateMessage = "连接成功";
        this.electronicScreenState_style.color = "green";
        break;
      case ElectronicScreenState.connectFailed:
        this.electronicScreenStateMessage = "连接失败";
        this.electronicScreenState_style.color = "red";
        break;
      default:
        this.electronicScreenStateMessage = "连接异常";
        this.electronicScreenState_style.color = "dark";
        break;
    }
  }
}
